<ul>
  <li *ngIf="detail.dateDebut">Du: {{ detail.dateDebut }}</li>
  <li *ngIf="detail.dateFin">Au: {{ detail.dateFin }}</li>
  <li>Motif: {{ detail.motif }}</li>
</ul>
